import React, { memo, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import './css/Roster1.css';
import { context } from '../../../globalState/GlobalState';
import Spinner1 from '../../uiElements/spinners/spinner1/Spinner1';
import { isValidObject, isValidString } from '../../../catalog/Validity';
import { getPlayerInfo } from '../../../catalog/Website';
import BreadCrumbs1 from '../../uiElements/breadCrumbs/breadCrumbs1/BreadCrumbs1';
import RostersComponent1 from '../../uiElements/rostersComponents/rostersComponent1/RostersComponent1';
import Title1 from '../../uiElements/title/title1/Title1';
import PlayerThumbnail1 from '../../uiElements/playerAndCoachThumbnails/playerThumbnails/playerThumbnail1/PlayerThumbnail1';
import AdComponent1 from '../../uiElements/adComponents/adComponent1/AdComponent1';

const Roster1 = (props) => {
    const { players, loadingSpinner } = props;
    const history = useHistory();
    const { globalState } = useContext(context);

    const getBreadCrumbsLinks = () => {
        return [
            {
                title: 'Home',
                link: '/',
            },
        ];
    };

    const isAlumni = () => {
        return (history.location.pathname === '/alumni');
    };

    const getPlayers = () => {
        return players.sort((playerA, playerB) => {
            return ((parseInt(getPlayerInfo(playerA.details, 'Team Number'), 10) > parseInt(getPlayerInfo(playerB.details, 'Team Number'), 10)) ? 1 : ((parseInt(getPlayerInfo(playerB.details, 'Team Number'), 10) > parseInt(getPlayerInfo(playerA.details, 'Team Number'), 10)) ? -1 : 0));
        });
    };

    const getAdComponent = (player, playerIndex) => {
        if (playerIndex % 10 === 9) {
            return (
                <AdComponent1
                    showDesktop
                    showMobile
                    desktopContainerId={`ads-container-${player.id}`}
                    mobileContainerId={`ads-container-${player.id}`}
                    placementId="roster"
                />
            );
        }

        return null;
    };

    return (
        <>
            <BreadCrumbs1 links={getBreadCrumbsLinks()} lastCrumb={isAlumni() ? 'Alumni' : 'Roster'} marginLeft="100px" />
            <div className="players1-container x-center bg-white curve-border-30px box-shadow-black p-t-20px p-l-100px p-r-100px p-b-100px m-t-50px m-b-30px">
                <Title1 title={isAlumni() ? 'Alumni' : 'Roster'} />
                <div className="players1">
                    {loadingSpinner ? (<Spinner1 color={globalState.websiteStyles.colors.primaryColor} />) : (
                        <>
                            {players.length > 0 ? (
                                <>
                                    {getPlayers().map((player, index) => {
                                        return (
                                            <React.Fragment key={player.id}>
                                                <PlayerThumbnail1 player={player} />
                                                {getAdComponent(player, index)}
                                            </React.Fragment>
                                        );
                                    })}
                                </>
                            ) : (<p className="alegreya-font-family font-weight-800 font-size-4xl full-width text-center-align">{isAlumni() ? 'Alumni Unavailable' : 'Roster Unavailable'}</p>)}
                        </>
                    )}
                </div>
                {isValidObject(globalState.logo) && isValidString(globalState.logo.logo2) ? (
                    <img src={globalState.logo.logo2} className="players1-icon m-t-50px m-b-0" alt={isValidString(globalState.teamName) ? globalState.teamName : 'Team Logo'} />
                ) : null}
            </div>
            <div className="players1-other-roster-container x-center m-t-40px">
                <RostersComponent1 />
            </div>
        </>
    );
};

Roster1.propTypes = {
    players: PropTypes.array.isRequired,
    loadingSpinner: PropTypes.bool.isRequired,
};

export default memo(Roster1);
